import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { StandaloneSelectField } from 'components/FormElements/FormSelectField';
import React, { useRef, useState } from 'react';
import { BarLoader } from 'react-spinners';
import {
  UpdateVenueAPIRequest,
  UploadVenueImageAPIRequest,
} from '../../../../../utils/constants/network';
import { callAPI } from '../../../../../utils/network/index';
import DeleteButton from '../../MenuEditor/components/shared/DeleteButton/index';
import './index.scss';

export const ReceiptSettingsDialog = ({
  locked,
  fullScreen,
  open,
  onClose,
  onSettingsSaved,
  showAlert,
  venue,
}) => {
  const [additionalInfo, setAdditionalInfo] = useState(
    venue.printing_additional_info || ''
  );
  const [numberOfCopies, setNumberOfCopies] = useState(
    venue.printing_num_copies || 1
  );
  const [savingSettings, setSavingSettings] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [receiptImageSrc, setReceiptImageSrc] = useState(
    venue.printing_logo_url || null
  );

  const selectImageInputRef = useRef(null);

  const onChangeFile = event => {
    event.stopPropagation();
    event.preventDefault();

    const fileReader = new FileReader();
    const file = event.target.files[0];

    if (file.size / 1024 / 1024 > 5) {
      showAlert(
        'Bad Image',
        'This image is too large. Try making the file size smaller and resubmit.'
      );
      return;
    }

    fileReader.onload = () => {
      setReceiptImageSrc(fileReader.result);
      uploadReceiptImage(fileReader.result);
    };

    fileReader.onerror = () => {
      fileReader.abort();
    };

    fileReader.readAsDataURL(file);
  };

  const uploadReceiptImage = async data => {
    setUploadingImage(true);

    const apiRequest = UploadVenueImageAPIRequest({
      file_base64_data: data,
      purpose: 'Venue Receipt Logo Image',
    });

    try {
      const { file } = await callAPI(apiRequest);
      setReceiptImageSrc(file);
    } catch (e) {
      setReceiptImageSrc(null);
      showAlert(
        'Image Error',
        `We could not upload the image: ${e.toString()}`
      );
    }

    setUploadingImage(false);
  };

  const saveReceiptSettings = async () => {
    setSavingSettings(true);

    const apiRequest = UpdateVenueAPIRequest({
      changes: {
        printing_additional_info: additionalInfo,
        printing_num_copies: numberOfCopies,
        printing_logo_url: receiptImageSrc,
      },
    });

    try {
      await callAPI(apiRequest);
      onSettingsSaved();
    } catch (e) {
      showAlert(
        'Update Error',
        `We could not save these changes: ${e.toString()}`
      );
    }

    setSavingSettings(false);
  };

  return (
    <Dialog
      className="dialog__receipt__printer"
      disableBackdropClick={locked}
      disableEscapeKeyDown={locked}
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="add-printer"
    >
      <DialogTitle
        className="dialog__receipt_printer__title"
        id="responsive-dialog-title"
      >
        Receipt Settings
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="centered__dialog__content__text">
          Customise your receipts to fit your venue.
        </DialogContentText>

        <div className="receipt__details">
          <React.Fragment>
            <input
              id="myInput"
              type="file"
              ref={selectImageInputRef}
              style={{ display: 'none' }}
              onChange={onChangeFile}
            />

            <div className="receipt__image__label">
              Venue Logo (Optional, Max 5MB)
            </div>

            {(!receiptImageSrc || uploadingImage) && (
              <Button
                onClick={() => selectImageInputRef.current.click()}
                className="receipt__choose__image__cta fatsoma__cta__secondary"
              >
                {!uploadingImage && 'Choose Image'}
                {uploadingImage && (
                  <BarLoader color="#000" width={100} height={4} />
                )}
              </Button>
            )}

            {receiptImageSrc && !uploadingImage && (
              <div className="receipt__image__preview">
                <img
                  src={receiptImageSrc}
                  alt="venue logo"
                  className="receipt__image"
                ></img>
                <DeleteButton
                  className="receipt__image__delete"
                  onClick={() => setReceiptImageSrc(null)}
                />
              </div>
            )}

            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth={true}
              label="Additional Text (Optional)"
              onChange={evt => setAdditionalInfo(evt.target.value)}
              value={additionalInfo}
              className="settings__section__details__form__name receipt__info"
              type="text"
              hinttext="Additional Info"
              placeholder="e.g. VAT Number, Address"
              margin="normal"
            />

            <StandaloneSelectField
              className="num__copies__select"
              label={<span>Number of copies</span>}
              autoFocus={true}
              value={numberOfCopies}
              onChange={evt =>
                setNumberOfCopies(parseInt(evt.target.value, 10))
              }
            >
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
            </StandaloneSelectField>
          </React.Fragment>
        </div>

        <div className="dialog__button__row">
          <Button
            className="fatsoma__cta__secondary"
            disabled={savingSettings}
            onClick={() => onClose()}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            className="fatsoma__cta"
            onClick={() => saveReceiptSettings()}
            autoFocus
          >
            {!savingSettings && 'Save'}
            {savingSettings && (
              <BarLoader color="#fff" width={100} height={4} />
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withMobileDialog()(ReceiptSettingsDialog);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Settings/ReceiptSettingsDialog/index.jsx